<template>
  <div class="content">
    <div class="survey_div" style="margin-bottom: .02rem;">
      <div class="barTitle">
        <strong style="width: 2.2rem;">有效意向</strong>
        <div class="ckTime">
          <span>
            <van-icon name="search" /><input type="text" v-model="table.number" name="text" @onBlur="table.currentPage=1;onLoad();" style="border:none;height: .36rem;width: 1.6rem;padding-left: .1rem;">
          </span>
          <span @click="statusShow=true">状态&nbsp;
            <van-icon name="arrow-down" />
          </span>
        </div>
      </div>
    </div>
    <div class="survey_div">
      <van-list v-model="table.loading" :finished="table.finished" finished-text="没有更多了" @load="onLoad" v-if="listLoading">
        <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
        <div class="clueItem" v-for="item in table.list">
          <p>
            <span class="cluePhone" v-text="item.phone"></span>
            <span class="clueStatic" v-if="item.status=='3'">
              <font color="#3B89FF">待跟进</font>
            </span>
            <span class="clueStatic" v-if="item.status=='4'">
              <font color="#07CF81">已跟进</font>
            </span>
            <span class="clueStatic" v-if="item.status=='5'">
              <font color="#07CFBF">已邀约</font>
            </span>
            <span class="clueStatic" v-if="item.status=='6'">
              <font color="#FF5A5A">未到店</font>
            </span>
            <span class="clueStatic" v-if="item.status=='7'">
              <font color="#07CF2D">已到店</font>
            </span>
            <span class="clueStatic" v-if="item.status=='8'">
              <font color="#666">未成交</font>
            </span>
          </p>
          <p>
            <span class="clueTime" v-text="item.updateTime">2020年1月15日 17:36:17</span>
            <span class="clueHref" @click="$router.push('/clueDesc?id='+item.lastRecordId)">查看详情></span>
          </p>
        </div>
      </van-list>
    </div>
    <van-popup v-model="show" position="bottom" round>
      <div style="padding: .4rem .4rem 0 .4rem;">
        <strong style="font-size: .32rem;color: #010101;">切换机构</strong>
      </div>
      <div style="padding: 0 .4rem;">
        <p v-for="item in organizationList" class="recharge4" @click="init(item)" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
          <span v-text="item.organizationName"></span>
        </p>
      </div>
    </van-popup>
    <van-popup v-model="statusShow" position="bottom" round>
      <div style="padding: .4rem .4rem 0 .4rem;">
        <strong style="font-size: .32rem;color: #010101;">切换状态</strong>
      </div>
      <div style="padding: 0 .4rem;">
        <p class="recharge4" @click="table.status='';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
          <span>全部</span>
        </p>
        <p class="recharge4" @click="table.status='3';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
          <span>待跟进</span>
        </p>
        <p class="recharge4" @click="table.status='4';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
          <span>已跟进</span>
        </p>
        <p class="recharge4" @click="table.status='5';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
          <span>已邀约</span>
        </p>
        <p class="recharge4" @click="table.status='6';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
          <span>未到店</span>
        </p>
        <p class="recharge4" @click="table.status='7';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
          <span>已到店</span>
        </p>
        <p class="recharge4" @click="table.status='8';table.currentPage=1;onLoad();" style="height: .99rem;line-height: .99rem;border-bottom: 1px solid #dedede;color: #222222;font-size: .3rem;margin: 0;">
          <span>未成交</span>
        </p>
      </div>
    </van-popup>
    <van-calendar v-model="dataShow" type="range" @confirm="onConfirm" :min-date="minDate" :default-date="defaultDate" />
  </div>
</template>
<script>
import { getOpenId, getOrganizationByOpenId, subAccountList, getTaskProgressByOrganizationId, moblieSurveyStatistics, getAbClueList } from '../../api';
import axios from 'axios';
import Echarts from "echarts";
export default {
  name: 'template',
  data() {
    return {
      echarts: "",
      value: "",
      show: false,
      dataShow: false,
      organizationList: [],
      organizationInfo: {},
      openId: "70cdf10d2a054b32ddb8afb6c1642046",
      wxConfig: {
        appid: "wx9fc68a7bac8f1258",
        url: location.href.split('#').toString()
      },
      searchObj: {
        organizationId: "",
        startDate: "",
        endDate: ""
      },
      token: "",
      taskPor: "",
      minDate: new Date(2019, 1, 1),
      defaultDate: [new Date(), new Date()],
      chartData: {
        abCountTotal: 0,
        calledTotal: 0,
        connectionRate: 0,
        phoneBillTotal: 0
      },
      listLoading: false,
      table: {
        list: [],
        finished: false,
        loading: false,
        currentPage: 1,
        number: "",
        organizationId: 0,
        showCount: 10,
        status: "",
        timeEnd: "",
        timeStart: "",
        total: 0
      },
      statusShow: false
    }
  },
  methods: {
    init(item) {
      this.organizationInfo = item;
      this.show = false;
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.searchObj.startDate = this.formatDate(start);
      this.searchObj.endDate = this.formatDate(end);
      this.searchData();
      this.dataShow = false;
    },
    lastDays(days) {
      days = days - 1;
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * days);
      end.setTime(end.getTime());
      return [start.getFullYear() + "-" + (start.getMonth() + 1) + "-" + start.getDate(), end.getFullYear() + "-" + (end.getMonth() + 1) + "-" + end.getDate()];
    },
    getOpenId(code) {
      var that = this;
      getOpenId("?code=" + code).then(function (res) {
        if (res.code == 1) {
          that.openId = res.data;
          if (window.history) {
            window.history.pushState("", "", window.location.origin + "/recharge");
          }
          that.getOrganizationByOpenId();
        } else {
          that.$toast(res.message)
        }
      })
    },
    getOrganizationByOpenId() {
      var that = this;
      getOrganizationByOpenId("?openId=" + that.openId).then(function (res) {
        if (res.code == 1) {
          axios.interceptors.request.use(function (response) {
            response.headers.Authorization = res.data.token;
            return response;
          }, function (error) {
            // alert('网络错误');
            that.$toast("网络错误，请刷新重试")
            return Promise.reject(error);
          });
          that.organizationInfo = res.data;
          // that.token = res.data.token;
          that.getOrganizationList();
          that.searchData(1);
          that.listLoading = true;
        } else {
          that.$toast(res.message)
        }
      })
    },
    getOrganizationList() {
      var that = this;
      subAccountList().then((res) => {
        if (res.code == 1) {
          that.organizationList = res.data;
        } else {
          that.$toast("错误信息:" + res.message);
        }
      });
    },
    searchData(days) {
      var that = this;
      that.searchObj.organizationId = that.organizationInfo.id;
      if (typeof (days) != "undefined") {
        that.searchObj.startDate = that.lastDays(days)[0];
        that.searchObj.endDate = that.lastDays(days)[1];
      }
      getTaskProgressByOrganizationId("?organizationId=" + that.searchObj.organizationId).then((res) => {
        if (res.code == 1) {
          that.taskPor = res.data.completeCount + "/" + res.data.totalCount;
        } else {
          that.$toast("错误信息:" + res.message);
        }
      });
      moblieSurveyStatistics(that.searchObj).then((res) => {
        if (res.code == 1) {
          that.chartData = res.data;
          that.setChart(res.data);
        } else {
          that.$toast("错误信息:" + res.message);
        }
      });
    },
    setChart(data) {
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        series: [
          {
            name: '意向类别',
            type: 'pie',
            radius: ['35%', '50%'],
            color: ["#ff6d42", "#ff9572", "#ffa769", "#ffb462", "#ffca6b", "#b7d3ff", "#7faeff", "#538fff"],
            data: [
              { value: data.acount, name: 'A  精准意向' },
              { value: data.bcount, name: 'B  一般意向' },
              { value: data.ccount, name: 'C  未接号码' },
              { value: data.dcount, name: 'D 无意向' },
              { value: data.ecount, name: 'E  年龄不符' },
              { value: data.fcount, name: 'F  位置不符' },
              { value: data.gcount, name: 'G  潜在投诉' },
              { value: data.hcount, name: 'H  无效号码' },
            ]
          }
        ]
      };
      this.echarts.setOption(option);
    },
    onLoad() {
      var that = this;
      // that.table.finished = false;
      that.table.organizationId = that.organizationInfo.id;
      getAbClueList(that.table).then((res) => {
        if (res.code == 1) {
          if (that.table.currentPage == 1) {
            that.table.list = [];
          }
          for (var i in res.data.list) {
            that.table.list.push(res.data.list[i]);
          }
          that.statusShow = false;
          that.table.loading = false;
          if (that.table.currentPage * that.table.showCount >= res.data.total) {
            that.table.finished = true;
          } else {
            that.table.finished = false;
          }
          that.currentPage++;
        } else {
          that.$toast("错误信息:" + res.message);
        }
      });
      // setTimeout(() => {
      //     for (let i = 0; i < 10; i++) {
      //       this.list.push(this.list.length + 1);
      //     }
      //     // 加载状态结束
      //     this.loading = false;

      //     // 数据全部加载完成
      //     if (this.list.length >= 40) {
      //       this.finished = true;
      //     }
      // }, 500);
    }
  },
  mounted() {
    // if(this.getQueryString("code")==null||this.getQueryString("code")==""){
    //     var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+this.wxConfig.appid+"&" + "redirect_uri=" + encodeURIComponent(this.wxConfig.url) + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    //     window.location.href = url;
    // }else{
    //     this.getOpenId(this.getQueryString("code"));
    // }
    this.echarts = Echarts.init(document.getElementById('echarts'));
    this.getOrganizationByOpenId();
  }
}
</script>
<style type="text/css">
.survey_div {
  background-color: #fff;
  width: 100%;
  margin-bottom: 0.2rem;
  padding: 0 0.3rem;
}
.searchBar {
  height: 1rem;
  display: flex;
  justify-content: flex-start;
}
.barTitle {
  display: flex;
  height: 1rem;
  justify-content: flex-start;
  align-items: center;
}
.barTitle strong {
  font-size: 0.32rem;
  color: #222222;
}
.organizationName {
  color: #222222;
  font-size: 0.26rem;
  width: 2.2rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
}
.organizationName span {
  max-width: 1.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ckTime {
  width: calc(100% - 2.2rem);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.ckTime span {
  height: 0.4rem;
  line-height: 0.36rem;
  border-radius: 0.2rem;
  padding: 0 0.2rem;
  text-align: center;
  color: #848483;
  font-size: 0.22rem;
  border: 0.02rem solid rgba(181, 181, 181, 1);
  display: flex;
  align-items: center;
  /*margin: 0 .1rem;*/
  margin-left: 0.2rem;
}
.organizationInfo {
  display: flex;
  justify-content: center;
  font-size: 0.28rem;
  color: #777777;
  text-align: center;
  padding: 0.2rem 0;
}
.organizationInfo strong {
  font-size: 0.6rem;
}
.organizationInfo a {
  display: inline-block;
  height: 0.52rem;
  line-height: 0.52rem;
  padding: 0 0.35rem;
  background: rgba(243, 246, 251, 1);
  color: #3b89ff;
  font-size: 0.24rem;
  border-radius: 0.26rem;
}
.organizationInfo p {
  margin: 0.1rem 0;
}
.chart_head {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.5rem;
  text-align: center;
  border-bottom: 0.02rem solid #f3f3f3;
}
.chart_head .num {
  display: block;
  color: #222222;
  font-size: 0.36rem;
}
.chart_head .desc {
  display: block;
  color: #777777;
  font-size: 0.24rem;
  margin-top: 0.1rem;
}
.chart_head .line {
  width: 1px;
  height: 0.42rem;
  background: rgba(238, 238, 238, 1);
}
.chart_foot {
  padding: 0.5rem 0;
}
.chart_foot .type {
  width: 1.2rem;
  height: 0.2rem;
  line-height: 0.2rem;
  border-left: 0.2rem solid;
  padding-left: 0.1rem;
  font-size: 0.22rem;
  color: #777777;
  margin: 0 0.1rem;
}
.clueItem {
  padding: 0.15rem 0;
  border-bottom: 1px solid #f3f3f3;
}
.clueItem p {
  margin: 0.1rem 0;
  display: flex;
  justify-content: flex-start;
}
.clueItem .cluePhone {
  width: 70%;
  color: #000;
  font-size: 0.34rem;
}
.clueItem .clueTime {
  width: 70%;
  color: #777;
  font-size: 0.28rem;
}
.clueItem .clueStatic {
  width: 30%;
  text-align: right;
  font-size: 0.28rem;
}
.clueItem .clueHref {
  width: 30%;
  text-align: right;
  color: #999;
  font-size: 0.24rem;
}
</style>


// WEBPACK FOOTER //
// src/views/clue/list.vue


// WEBPACK FOOTER //
// src/views/clue/list.vue